/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";
import { switchClasses } from "@mui/material/Switch";

export const muiSwitchStyle = (): Components<Theme>["MuiSwitch"] => ({
  styleOverrides: {
    root: {
      [`& .${switchClasses.colorPrimary}.${switchClasses.disabled}`]: {
        /* TODO: Check if theme var can be used */
        color: "#bcdada",
        [`& + .${switchClasses.track}`]: {
          backgroundColor: "#137f7b",
        },
      },
    },
  },
});
